import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, notification, Drawer, Button, Space } from "antd";
import { FaEdit, FaEye, FaDownload, FaSortAlphaDown, FaSortAlphaUp, FaArrowsAltV, FaSortNumericDown, FaSortNumericUp } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Pagination from "@mui/material/Pagination";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import TobNavBar from "../../pages/DashBaord/Top_navbar";
import { Link, useNavigate } from "react-router-dom";
import ConfirmPopup from './ConfirmPopUp';
import ImportPopUp from './ImportPopUp';
import ImportApprovePopUp from './ImportApprovePopUp';
import * as XLSX from 'xlsx';

import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  LikeOutlined,
  DislikeOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined
} from "@ant-design/icons";

import moment from "moment";
import { ASSETS_BASE_URL } from "../../../src/config/constants";
import SkeltonList from "../../../src/components/SkeltonEffect/list";
import {
    list,
  chnageStatus,changePiority
} from "../../../src/controllers/interests/requestsController";
import { getPageMore, statusInterestMessage } from "../../../src/controllers/common";

import { FaPlusSquare } from "react-icons/fa";

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {

  const [popUpOpen, setPopUpOpen] = useState(false);
  const togglePopUp = () => {
    setPopUpOpen(!popUpOpen);
  };

  const [importPopUpOpen, setImportPopUpOpen] = useState(false);
  const toggleImporPopUp = () => {
    setImportPopUpOpen(!importPopUpOpen);
  };

  const [importApprovePopUpOpen, setImportApprovePopUpOpen] = useState(false);  // new
  const toggleApproveImporPopUp = () => {
    setImportApprovePopUpOpen(!importApprovePopUpOpen);
  };

  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => {
    setFilterShow(!isFilterShow);
  } 

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [deleteId, setDeleteId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(20);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const [showApprovedRequest, setShowApprovedRequest] = useState("");
  const [totalrequestedcount, settotalrequestedcount] = useState("");

  /*********************************************************
   *  This function is use to fetch investors list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(showRequest ? { status: showRequest } : null),
          ...(showApprovedRequest ? { admin_status: showApprovedRequest } : null),
        },
        ...(filter?{filter:filter}:null),
        select: {},
        // sort: { status: 1, _id: -1 },
        sort: {
          // status: 1,
          // ...(sortByFirmname
          //   ? { investor_firm_name: sortByFirmname === "Y" ? 1 : -1 }
          //   : { _id: 1 }),
          // ...(sortByInvestorname
          //   ? { investor_first_name: sortByInvestorname === "Y" ? 1 : -1 }
          //   : { _id: 1 }),
          // ...(sortByCompname
          //   ? { company_name: sortByCompname === "Y" ? 1 : -1 }
          //   : { _id: 1 }),
          ...(sortByFirmname && { investor_firm_name: sortByFirmname === "Y" ? 1 : -1 }),
          ...(sortByInvestorname && { investor_first_name: sortByInvestorname === "Y" ? 1 : -1 }),
          ...(sortByCompname && { company_name: sortByCompname === "Y" ? 1 : -1 }),
          ...(sortByDate && { createdAt: sortByDate === "Y" ? 1 : -1 }),
          ...(sortByPriority && { investor_priority: sortByPriority === "Y" ? 1 : -1 }),
        },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 20,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
        } else {
          setListData([]);
        }
        const countOptions = {
          type: "count",
          condition: {
            ...(showRequest ? { status: showRequest } : null),
            ...(showApprovedRequest ? { admin_status: showApprovedRequest } : null),
          },
          ...(filter?{filter:filter}:null)
        };
        const count = await list(countOptions);
        settotalrequestedcount(count?.result);
        setTotalPages(getPageMore(count?.result));
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  const [selectedFilterField, setSelectedFilterField] = useState("");

  // handle filter_by change (just updates state, no API call)
  const handleFilterByChange = (e) => {
    setSelectedFilterField(e.target.value);
  };
  // reset filter
  const handleFilterReset = () => {
    try {
      setSkip(0);
      setCurrentPage(1);
      setFilter("");
      setSelectedFilterField(""); // reset selected filter field
      inputRef1.current.value = "";
      inputRef2.current.value = "";
      inputRef3.current.value = "";
      inputRef4.current.value = "";
    } catch (error) {}
  };

  // apply filter (API hit here only)
  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);

      // base filter
      const newFilter = {
        filter_by: form.get("filter_by") || "",
        search: form.get("search") || "",
      };

      // only add dates if "createdAt" selected
      if (form.get("filter_by") === "createdAt") {
        newFilter.from = form.get("from_date") || "";
        newFilter.to = form.get("to_date") || "";
      }

      setFilter(newFilter);
      setSkip(0);
      setCurrentPage(1);
      handleFiterDrawer();
    } catch (error) {}
  };
  // const handleFilterByChange = (e) => {
  //   const value = e.target.value;
  //   setFilter((prev) => ({
  //     ...prev,
  //     filter_by: value,
  //     // reset from/to if filter_by is not createdAt
  //     ...(value !== "createdAt" ? { from: "", to: "" } : {})
  //   }));
  // };


  const [sortByFirmname, setSortByFirmName] = useState("");
  const handleFirmNameSort = () => {
    setSortByInvestorName("");
    setSortByCompName("");
    setSortByDate("");
    setSortByPriority("");
    setSortByFirmName((prevSort) => (prevSort === "Y" ? "N" : "Y"));
  };

  const [sortByInvestorname, setSortByInvestorName] = useState("");
  const handleInvestorNameSort = () => {
    setSortByFirmName("");
    setSortByCompName("");
    setSortByDate("");
    setSortByPriority("");
    setSortByInvestorName((prevSort) => (prevSort === "Y" ? "N" : "Y"));
  };

  const [sortByCompname, setSortByCompName] = useState("");
  const handleCompNameSort = () => {
    setSortByFirmName("");
    setSortByInvestorName("");
    setSortByDate("");
    setSortByPriority("");
    setSortByCompName((prevSort) => (prevSort === "Y" ? "N" : "Y"));
  };

  const [sortByDate, setSortByDate] = useState("");
  const handleDateSort = () => {
    setSortByFirmName("");
    setSortByInvestorName("");
    setSortByCompName("");
    setSortByPriority("");
    setSortByDate((prevSort) => (prevSort === "Y" ? "N" : "Y"));
  };

  const [sortByPriority, setSortByPriority] = useState("");
  const handlePrioritySort = () => {
    setSortByFirmName("");
    setSortByInvestorName("");
    setSortByDate("");
    setSortByCompName("");
    setSortByPriority((prevSort) => (prevSort === "Y" ? "N" : "Y"));
  };

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };


  /*********************************************************
   *  This function is use to change investor status
   *********************************************************/
  const handleStatusChnage = async (status = "", id) => {
    try {
      setListData([]);
      const options = {
        url: `requests/change-status`,
        postData: {
          id: id,
          status: status,
        },
      };
      const res = await chnageStatus(options);
      if (res.status === true) {
        notification.open({
          message: "Data updated.",
          description: `Status updated successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Opps!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Opps!",
        description: `Operation not perform yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    getList();
  };

  /*********************************************************
   *  This function is use to change investor status
   *********************************************************/
  const handleApproveReq = async (status = "", id) => {
    try {
      setListData([]);
      const options = {
        url: `requests/approve-request`,
        postData: {
          id: id,
          admin_status: status,
        },
      };
      const res = await chnageStatus(options);
      if (res.status === true) {
        notification.open({
          message: "Data updated.",
          description: `Interest approved successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Opps!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Opps!",
        description: `Operation not perform yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    getList();
  };


  /*********************************************************
   *  This function is use to change investor status
   *********************************************************/
  const handlePriorityChnage = async (priority = "", id) => {
    try {
      setListData([]);
      const options = {
        url: `requests/change-priority`,
        postData: {
          id: id,
          priority: priority,
        },
      };
      const res = await changePiority(options);
      if (res.status === true) {
        notification.open({
          message: "Data updated.",
          description: `Priority updated successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Opps!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Opps!",
        description: `Operation not perform yet! please try in some time.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
    getList();
  };

  //// export excel
    const handleExportInterests = async () => {
      // setIsExportLoading(true);
      // setExportLoadingText('Loading Data....');
      try {
          const exportOptions = {
            type: "",
            condition: {}
          };
          // console.log('endDate', endDate);
          // console.log('endDate',endDate);
          const exportDatas = await list(exportOptions);
          // console.log('API res time bat', exportDatas);
          if (exportDatas.status === true) {
            if (exportDatas?.result.length > 0) {
              prepareSheetData(exportDatas?.result);
            } else {
              alert('No data found');
            }
          } else {
            // setIsExportLoading(false);
            console.log('api error');
          }
      } catch (error) {
        // setIsExportLoading(false);
        console.log("error", error);
      } finally {
        // setIsExportLoading(false);
      }
    }
    const prepareSheetData = (data) => {
      console.log('dataCount -', data.length);
      // setExportLoadingText('Preparing Your Data....');
      const mySheet = data.map((items) => {
  
        return {
          "Interest Id": items?._id,
          "Investing Firm": items?.investor_data?.investor_firm_name || '',
          "Investor Name": `${items?.investor_users?.investor_first_name} ${items?.investor_users?.investor_last_name}`,
          "Designation": items?.investor_users?.investor_designation || '',
          "Email": items?.investor_users?.investor_email || '',
          "Portfolio Company": items?.company_data?.company_name || '',
          "Priority": items?.investor_priority,
          "Admin Approved": items?.admin_status,
          "Interest Status": items?.status,
          "Created At": items?.createdAt ? moment(`${items?.createdAt}`).format("DD/MM/YYYY, h:mm A") : '',
        }
      });
      // setDataSheet(mySheet);
      downloadExcel(mySheet);
      // setIsExportLoading(false);
    }
  
    const downloadExcel = (dataSheet = []) => {
      // Create a new workbook
      const workbook = XLSX.utils.book_new();
  
      // Convert data for each sheet
      const worksheet = XLSX.utils.json_to_sheet(dataSheet);
  
      // Append sheets to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Investors-Interest Shown");
  
      // Trigger download
      XLSX.writeFile(workbook, "InvestorInterests.xlsx");
    };
    //// export excel


  const dropdownMenu = (items) => {
    return (
      <>
        <Menu>
          {items?.admin_status === 'P' && (
            <Menu.Item
              key={`01`}
              onClick={() => {
                handleApproveReq("A", items._id);
              }}
            >
              <CheckCircleOutlined /> <span className="show_span">Approve</span>
            </Menu.Item>
          )}
          {items?.status !== 'A' && (
            <Menu.Item
              key={`02`}
              onClick={() => {
                handleStatusChnage("A", items._id);
              }}
            >
              <LikeOutlined /> <span className="show_span">Accept</span>
            </Menu.Item>
          )}
        {items?.status !== 'R' && (
          <Menu.Item
            key={`03`}
            onClick={() => {
              handleStatusChnage("R", items._id);
            }}
          >
            <DislikeOutlined /> <span className="show_span">Decline</span>
          </Menu.Item>
        )}
        {items?.status !== 'P' && (
          <Menu.Item
            key={`04`}
            onClick={() => {
              handleStatusChnage("P", items._id);
            }}
          >
            <InfoCircleOutlined /> <span className="show_span">Pending</span>
          </Menu.Item>
        )}

        {items?.status !== 'C' && (
          <Menu.Item
            key={`05`}
            onClick={() => {
              handleStatusChnage("C", items._id);
            }}
          >
            <InfoCircleOutlined /> <span className="show_span">Cancel</span>
          </Menu.Item>
        )}

          {items?.investor_priority === 1 && (
            <Menu.Item
              key={`06`}
              onClick={() => {
                handlePriorityChnage(2, items._id);
              }}
            >
              <ArrowDownOutlined /> <span className="show_span">Set Priority to 2</span>
            </Menu.Item>
          )}
          {items?.investor_priority === 2 && (
            <Menu.Item
              key={`07`}
              onClick={() => {
                handlePriorityChnage(1, items._id);
              }}
            >
              <ArrowUpOutlined /> <span className="show_span">Set Priority to 1</span>
            </Menu.Item>
          )}
        </Menu>
      </>
    );
  };

  /*********************************************************
   *  This function is ued for handle filter input chnage
   *********************************************************/
  // const handleFilterReset = () => {
  //   try {
  //     setSkip(0);
  //     setCurrentPage(1);
  //     setFilter('');
  //     inputRef1.current.value = '';
  //     inputRef2.current.value = '';
  //     inputRef3.current.value = '';
  //     inputRef4.current.value = '';
  //   } catch (error) {
      
  //   }
  // }

  // const handleFilterApply = (e) => {
  //   try {
  //     e.preventDefault();
  //     const form = new FormData(e.target);
  //     setFilter((pre)=>({
  //       ...pre,
  //       'filter_by' : form.get('filter_by') || '',
  //       'search'    : form.get('search') || '',
  //       'to'        : form.get('to_date') || '',
  //       'from'      : form.get('from_date') || '',

  //     }))
  //     // console.log('filter',filter);
  //     // alert('submit');
  //     setSkip(0);
  //     handleFiterDrawer();
  //     // setSkip(0);
  //   } catch (error) {
      
  //   }
  // }

  
  const handleCreateInterest = async () => {
    navigate("/requests-sent/create");
  };

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Chiratae Super Admin || Interests List";
  }, [currentPage, showRequest, showApprovedRequest, popUpOpen, filter, importPopUpOpen, importApprovePopUpOpen, sortByFirmname, sortByInvestorname, sortByCompname, sortByDate, sortByPriority]);

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Interest List"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setShowRequest("");
                        setShowApprovedRequest("");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                    <Tab
                      label="Approved"
                      className="tabs_main_contnet"
                      {...a11yProps(1)}
                      onClick={() => {
                        setShowRequest("");
                        setShowApprovedRequest("A");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                    <Tab
                      label="Non-Appr"
                      className="tabs_main_contnet"
                      {...a11yProps(1)}
                      onClick={() => {
                        setShowRequest("");
                        setShowApprovedRequest("P");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                    <Tab
                      label="Pending"
                      className="tabs_main_contnet"
                      {...a11yProps(2)}
                      onClick={() => {
                        setShowApprovedRequest("");
                        setShowRequest("P");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                    <Tab
                      label="Accepted"
                      className="tabs_main_contnet"
                      {...a11yProps(3)}
                      onClick={() => {
                        setShowApprovedRequest("");
                        setShowRequest("A");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                    <Tab
                      label="Rejected"
                      className="tabs_main_contnet"
                      {...a11yProps(4)}
                      onClick={() => {
                        setShowApprovedRequest("");
                        setShowRequest("R");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                    <Tab
                      label="Cancelled By Admin"
                      className="tabs_main_contnet"
                      {...a11yProps(5)}
                      onClick={() => {
                        setShowApprovedRequest("");
                        setShowRequest("C");
                        setSkip(0);
                        setCurrentPage(1);
                      }}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <img
                      src={ASSETS_BASE_URL + "/images/Filter.svg"}
                      alt="filter"
                      className="user_iconses"
                    />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filters
                    </Link>
                  </div>
                  <div onClick={togglePopUp}>
                    <button type="button" class="btn btn-dark">
                      <span className="request_new_categories">Schedule Meetings</span>
                    </button>
                  </div>

                </div>
              </div>
            </Box>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                </div>
                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div
                    onClick={() => {
                      handleExportInterests();
                    }}
                  >
                    <button type="button" class="btn btn-info">
                      <FaDownload className="Promotions_faPlus_Squares" />
                      <span className="request_new_categories">
                        Export Interests
                      </span>
                    </button>
                  </div>
                  <div onClick={toggleApproveImporPopUp}>
                    <button type="button" class="btn btn-dark">
                      <span className="request_new_categories">Import Approved interests</span>
                    </button>
                  </div>
                  <div onClick={handleCreateInterest}>
                    <button type="button" class="btn btn-dark">
                      <span className="request_new_categories">Create interests</span>
                    </button>
                  </div>
                </div>
              </div>
            </Box>
            {/* First Inventory */}
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            { totalrequestedcount ? (
                              <tr><th style={{color:"red", fontSize:"18px",fontWeight:"600"}} colSpan={2}>{`Total - ${totalrequestedcount}`}</th></tr>
                            ):null}                            
                            <tr>
                              <th style={{width:"8%"}}>Sr no.</th>
                              <th>Request Id</th>
                              <th>Investor's Firm {sortByFirmname === "Y" ? (
                                <FaSortAlphaDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleFirmNameSort()}
                                />
                              ) : (
                                <FaSortAlphaUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleFirmNameSort()}
                                />
                              )}
                              </th>
                              <th>Investor {sortByInvestorname === "Y" ? (
                                <FaSortAlphaDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleInvestorNameSort()}
                                />
                              ) : (
                                <FaSortAlphaUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleInvestorNameSort()}
                                />
                              )}
                              </th>
                              <th>Company {sortByCompname === "Y" ? (
                                <FaSortAlphaDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleCompNameSort()}
                                />
                              ) : (
                                <FaSortAlphaUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleCompNameSort()}
                                />
                              )}
                              </th>
                              <th>Priority {sortByPriority === "Y" ? (
                                <FaSortAlphaDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handlePrioritySort()}
                                />
                              ) : (
                                <FaSortAlphaUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handlePrioritySort()}
                                />
                              )}</th>
                              <th>Created At
                                {sortByDate === "Y" ? (
                                <FaSortNumericDown
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleDateSort()}
                                />
                              ) : (
                                <FaSortNumericUp
                                  style={{
                                    marginLeft: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleDateSort()}
                                />
                              )}
                              </th>
                              <th>Status</th>
                              <th>Approve Status</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{(currentPage - 1) * 20 + index + 1}</td>
                                    <td className="admin_user_list_date"> {items?.resuest_id} </td>
                                    <td className="admin_user_list_date"> {items?.investor_data?.investor_firm_name} </td>
                                    <td className="admin_user_list_date">
                                      {items?.investor_users?.investor_first_name} {" "}{items?.investor_users?.investor_last_name} ({items?.investor_users?.investor_designation})
                                    </td>
                                    <td className="admin_user_list_date">
                                      {" "}
                                      {items?.company_data?.company_name}
                                    </td>
                                    <td className="admin_user_list_date">
                                      {(items?.investor_priority === 1 || items?.investor_priority === '1')?'First':'Second'}
                                    </td>
                                    <td className="admin_user_list_date">
                                      {moment(`${items?.createdAt}`).format(
                                        "DD/MM/YYYY, h:mm A"
                                      )}{" "}
                                    </td>
                                    <td
                                      className="admin_user_list_date"
                                      dangerouslySetInnerHTML={{
                                        __html: statusInterestMessage(items.status),
                                      }}
                                    ></td>
                                    <td>{items.admin_status === 'A' &&  'Approved'} {items.admin_status === 'P' &&  'Pending'} {items.admin_status === 'R' &&  'Rejected'} </td>
                                    <td>
                                      <Dropdown
                                        overlay={() => dropdownMenu(items)}
                                        placement="bottomLeft"
                                        arrow
                                      >
                                        <HiOutlineDotsHorizontal style={{cursor:"pointer"}}/>
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={9} /> : <tr> 
                                <td colspan="5" className="img-center" ><p>No data to show</p></td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                            page={currentPage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
        <ConfirmPopup
          popUpOpen={popUpOpen}
          togglePopUp={togglePopUp}
        />
        <ImportPopUp
          popUpOpen={importPopUpOpen}
          togglePopUp={toggleImporPopUp}
        />
        <ImportApprovePopUp
          popUpOpen={importApprovePopUpOpen}
          togglePopUp={toggleApproveImporPopUp}
        />
      </div>
      {/* Filter */}
      <Drawer
        title="Interests Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="investor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1} onChange={handleFilterByChange}>
                  <option value=''>Select search field</option>
                  <option value='investor_firm_name' selected={filter?.filter_by ==='investor_firm_name'?true:false}>Investor Firm</option>
                  <option value='investor_first_name' selected={filter?.filter_by ==='investor_first_name'?true:false}>Investor Name</option>
                  <option value='company_name' selected={filter?.filter_by ==='company_name'?true:false}>Company Name</option>
                  <option value='investor_priority' selected={filter?.filter_by ==='investor_priority'?true:false}>Priority</option>
                  <option value='createdAt' selected={filter?.filter_by ==='createdAt'?true:false}>Created At</option>
                </select>
              </div>
              {selectedFilterField && selectedFilterField != 'investor_priority' && selectedFilterField != "createdAt" && (
              <>
                <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <label htmlFor="investor_first_name" className="all_section_for_label_main_class" >
                    Search Text :
                  </label>
                  <input
                    title="Enter search text."
                    placeholder="Enter search text."
                    type="text"
                    name="search"
                    className="form-control store_input_field"
                    id="search"  
                    ref={inputRef2}            
                  />
                </div>
                </>
              )}
              {/* Priority dropdown */}
              {selectedFilterField === 'investor_priority' && (
                <div className="form-group col-lg-12">
                  <label>Priority :</label>
                  <select name="search" className="form-control store_input_field">
                    <option value="">Select Priority</option>
                    <option value="1">First</option>
                    <option value="2">Second</option>
                  </select>
                </div>
              )}
              {selectedFilterField === "createdAt" && (
              <>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="investor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                  // onChange={handleFilterChnage}          
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="investor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                  // onChange={handleFilterChnage}             
                />
              </div>
              </>
              )}
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
